import { post } from "../utils/backend";
import { IdentityAudit, IdentityAuditRequest } from "../models/IdentityAudit";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/IdentityAuditMock";

const getAllCandidates = async (): Promise<IdentityAudit[]> => {
    if (mock) {
        return getMockData("identity_audit_candidates");
    }
    const resultOrErrorCode = await post<null, IdentityAudit[]>("/audit/realname/getAllCandidates", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getAllProcessed = async (): Promise<IdentityAudit[]> => {
    if (mock) {
        return getMockData("identity_audit_processed");
    }
    const resultOrErrorCode = await post<null, IdentityAudit[]>("/audit/realname/getAllProcessed", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const identityAudit = async (params: IdentityAuditRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<IdentityAuditRequest, boolean>("/audit/realname/audit", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const identityAuditApi = {
    getAllCandidates,
    getAllProcessed,
    identityAudit
}; 